export enum MedicationStateEnum {
  taken = 'taken',
  notTaken = 'not-taken',
  rescheduledTo = 'rescheduled-to',
  rescheduledFrom = 'rescheduled-from',
  unknown = 'unknown',
}
